<div class="dialog-header">
  <span class="spacer"></span>
  <span class="header-label">{{ 'History for ' + entityId }}</span>
  <span class="spacer"></span>
  <button matButton="elevated" class="close-dialog-button warn-button" (click)="close()">X</button>
</div>
@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
<div class="content">
  @let history = entityHistory();
  <div class="data-wrapper">
    <div class="data-row">
      <span class="data-label">Date Created:</span>
      <span class="value-label">{{ history?.createDate | date: 'MM/dd/yyyy hh:mm:ss a' }}</span>
    </div>
    <div class="data-row">
      <span class="data-label">SFR Submitted:</span>
      <span class="value-label">{{ history?.sfrSent | date: 'MM/dd/yyyy hh:mm:ss a' }}</span>
    </div>
    <div class="data-row">
      <span class="data-label">SFR Approved:</span>
      <span class="value-label">{{ history?.sfrApprove | date: 'MM/dd/yyyy hh:mm:ss a' }}</span>
    </div>
    <div class="data-row">
      <span class="data-label">FPA Submitted:</span>
      <span class="value-label">{{ history?.fpaSubmitted | date: 'MM/dd/yyyy hh:mm:ss a' }}</span>
    </div>
    <div class="data-row">
      <span class="data-label">FPA Approved:</span>
      <span class="value-label">{{ history?.fpaApproved | date: 'MM/dd/yyyy hh:mm:ss a' }}</span>
    </div>
    <div class="data-row">
      <span class="data-label">Sent For Review:</span>
      <span class="value-label">{{ history?.review | date: 'MM/dd/yyyy hh:mm:ss a' }}</span>
    </div>
    <div class="data-row">
      <span class="data-label">Approved:</span>
      <span class="value-label">{{ history?.approve | date: 'MM/dd/yyyy hh:mm:ss a' }}</span>
    </div>
    <div class="data-row">
      <span class="data-label">Released:</span>
      <span class="value-label">{{ history?.release | date: 'MM/dd/yyyy hh:mm:ss a' }}</span>
    </div>
    <div class="data-row">
      <span class="data-label">Transferred to ERP:</span>
      <span class="value-label">{{ history?.transferToPrms | date: 'MM/dd/yyyy hh:mm:ss a' }}</span>
    </div>
  </div>
</div>
